export default __webpack_public_path__ + "static/media/reebok.a177de20.png";